// Packages
import { useState } from "react";
import { Route, Redirect } from "react-router-dom";

//Utils
import { getFromLocalStorage } from "../utils/webStorage";

function Index({ component: Component, exact, ...rest }) {
  const [isLogedIn] = useState(Boolean(getFromLocalStorage("user")));
  return (
    <Route
      exact={exact}
      {...rest}
      render={(props) =>
        isLogedIn ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
}

export default Index;
